import Marquee from "react-fast-marquee";

const items = ["Deep Tissue", "Hot Stone", "Aromatherapy", "Moroccan Bath", "Four Hands", "Open 24 Hours"];

export const MarqueeStrip = () => (
  <div data-testid="marquee-strip" className="border-y border-white/10 py-6 md:py-8 bg-ink-soft/40">
    <Marquee speed={30} gradient={false} pauseOnHover>
      {items.map((item) => (
        <span key={item} className="font-serif italic font-light text-2xl md:text-4xl text-stone-500 mx-8 md:mx-14 whitespace-nowrap">
          {item} <span className="text-gold-400 not-italic text-lg md:text-2xl align-middle">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
